import React from 'react'

import { PLANS } from '../../../constants/plans'
import { DOWNGRADE } from '../UpgradePayModal'
import { pluralize } from '../../../utils/general'
import { ToolTip } from '../../PricingGrid/components/PlanCard'

const FeatureList = ({ planId, stage, list, handleComparePlans }) => {
  return (
    <>
      {stage === DOWNGRADE &&
        list.map((feature) => {
          return (
            <div className="flex pt-2 ms-3 align-items-center opacity-80" key={feature.label}>
              <img className="me-2" height="15px" width="15px" alt="check" src="/assets/icons/x.png" />
              {feature?.label}
            </div>
          )
        })}
      {stage !== DOWNGRADE && planId === PLANS.PRO_U.id && (
        <>
          <div className="flex pt-3 ms-3 align-items-top bold">
            <img className="me-2 mt-1" height="15px" width="15px" alt="check" src="/check.png" /> Upload{' '}
            {PLANS.PRO_U.projectLimit === 999 ? 'Unlimited' : PLANS.PRO_U.projectLimit} projects
          </div>
          <div className="flex pt-2 ms-3 align-items-top bold">
            <img className="me-2 mt-1" height="15px" width="15px" alt="check" src="/check.png" /> Add up to one more
            team member <ToolTip text="Add more team members for +$5 each" />
          </div>
          <div className="flex pt-2 ms-3 align-items-center">
            <img className="me-2" height="15px" width="15px" alt="check" src="/check.png" /> Upload more than 75mb files
          </div>
          <div className="flex pt-2 ms-3 align-items-center">
            <img className="me-2" height="15px" width="15px" alt="check" src="/check.png" /> All Solo & Tiny plan
            features
          </div>
        </>
      )}
      {stage !== DOWNGRADE && planId === PLANS.PRO.id && (
        <>
          <div className="flex pt-3 ms-3 align-items-center bold">
            <img className="me-2" height="15px" width="15px" alt="check" src="/check.png" /> Connect your custom domain
          </div>
          <div className="flex pt-2 ms-3 align-items-center">
            <img className="me-2" height="15px" width="15px" alt="check" src="/check.png" /> Upload more than{' '}
            {PLANS.TINY.fileSizeLimit}mb files
          </div>
          <div className="flex pt-2 ms-3 align-items-center">
            <img className="me-2" height="15px" width="15px" alt="check" src="/check.png" /> Upload more than{' '}
            {PLANS.TINY.projectLimit} {pluralize('project', 'projects', PLANS.TINY.projectLimit)}
          </div>
          <div className="flex pt-2 ms-3 align-items-center">
            <img className="me-2" height="15px" width="15px" alt="check" src="/check.png" /> Edit your content
          </div>
          <div className="flex pt-2 ms-3 align-items-center opacity-50">
            <img className="me-2" height="15px" width="15px" alt="check" src="/assets/icons/x.png" /> Add team members
          </div>
        </>
      )}
      {stage !== DOWNGRADE && planId === PLANS.TINY.id && (
        <>
          <div className="flex pt-3 ms-3 align-items-center bold">
            <img className="me-2" height="15px" width="15px" alt="check" src="/check.png" /> {PLANS.TINY.projectLimit}{' '}
            active {pluralize('project', 'projects', PLANS.TINY.projectLimit)}
          </div>
          <div className="flex pt-2 ms-3 align-items-center">
            <img className="me-2" height="15px" width="15px" alt="check" src="/check.png" /> Upload up to{' '}
            {PLANS.TINY.fileSizeLimit}mb files
          </div>
          <div className="flex pt-2 ms-3 align-items-center">
            <img className="me-2" height="15px" width="15px" alt="check" src="/check.png" /> Remove Tiiny Host banner
          </div>
          <div className="flex pt-2 ms-3 align-items-center">
            <img className="me-2" height="15px" width="15px" alt="check" src="/check.png" /> Built in analytics
          </div>
          <div className="flex pt-2 ms-3 align-items-center">
            <img className="me-2" height="15px" width="15px" alt="check" src="/check.png" /> Up to 10,000 visits/mo
          </div>
          <div className="flex pt-2 ms-3 align-items-center opacity-50">
            <img className="me-2" height="15px" width="15px" alt="check" src="/assets/icons/x.png" /> Connect custom
            domain
          </div>
        </>
      )}
      {stage !== DOWNGRADE && planId === PLANS.PRO_MAX.id && (
        <>
          <div className="flex pt-3 ms-3 align-items-center bold">
            <img className="me-2" height="15px" width="15px" alt="check" src="/check.png" /> Unlimited projects
          </div>
          <div className="flex pt-2 ms-3 align-items-center">
            <img className="me-2" height="15px" width="15px" alt="check" src="/check.png" /> Upload upto 2TB
          </div>
          <div className="flex pt-2 ms-3 align-items-center">
            <img className="me-2" height="15px" width="15px" alt="check" src="/check.png" /> Priority support
          </div>
        </>
      )}
      {planId !== PLANS.API.id && (
        <div className="mt-4 font-16 ms-3 bg-white compare_plans" onClick={handleComparePlans}>
          <a className="cursor-pointer text-dark-grey text-decoration-none" target="_blank" rel="noreferrer">
            Compare plans →
          </a>
        </div>
      )}
    </>
  )
}

export default FeatureList
